<cmps-dialog>
    <cmps-dialog-header [closeTooltip]="_i18n._763_CLOSE | translate">
        <div
            class="cmps-cdk-font-size-20p cmps-cdk-text-center cmps-cdk-font-bold"
        >
            {{ _i18n._7378_COMMITMENT_DETAILS | translate }}
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body class="cmps-cdk-overflow-y-auto">
        <table class="cmps-cdk-my-0dot5">
            <thead
                class="cmps-cdk-align-items-center cmps-cdk-font-size-16p cmps-cdk-my-1 cmps-cdk-bg-color-grey-200"
            >
                <ng-container *ngFor="let c of _data.columns">
                    <ng-container [ngSwitch]="c">
                        <th
                            class="cmps-cdk-pl-0dot5 cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.DIRECT_REPORT
                            "
                        >
                            <button
                                cmpsButton
                                class="cmps-button--no-bg cmps-cdk-p-0 cmps-cdk-justify-content-flex-start"
                                (click)="_onColumnSortClick(c)"
                            >
                                <span
                                    cmpsButtonLabel
                                    class="cmps-wp-commitment-details-dialog--thead-btn cmps-cdk-font-size-16p cmps-cdk-font-bold cmps-cdk-color-black cmps-cdk-text-left"
                                >
                                    {{ _i18n._11107_DIRECT_REPORT | translate }}
                                </span>
                                <cmps-icon
                                    [svgIcon]="
                                        _sorter?.columnId !== c
                                            ? 'unfold-more-horizontal'
                                            : _sorter?.sortOrder ===
                                              _SortOrder.ASC
                                            ? 'chevron-up'
                                            : 'chevron-down'
                                    "
                                ></cmps-icon>
                            </button>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.START_DATE
                            "
                        >
                            <button
                                cmpsButton
                                class="cmps-button--no-bg cmps-cdk-p-0 cmps-cdk-justify-content-flex-start"
                                (click)="_onColumnSortClick(c)"
                            >
                                <span
                                    cmpsButtonLabel
                                    class="cmps-wp-commitment-details-dialog--thead-btn cmps-cdk-font-size-16p cmps-cdk-font-bold cmps-cdk-color-black cmps-cdk-text-left"
                                >
                                    {{ _i18n._75_START_DATE | translate }}
                                </span>
                                <cmps-icon
                                    [svgIcon]="
                                        _sorter?.columnId !== c
                                            ? 'unfold-more-horizontal'
                                            : _sorter?.sortOrder ===
                                              _SortOrder.ASC
                                            ? 'chevron-up'
                                            : 'chevron-down'
                                    "
                                ></cmps-icon>
                            </button>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.DAYS_ACTIVE
                            "
                        >
                            <button
                                cmpsButton
                                class="cmps-button--no-bg cmps-cdk-p-0 cmps-cdk-justify-content-flex-start"
                                (click)="_onColumnSortClick(c)"
                            >
                                <span
                                    cmpsButtonLabel
                                    class="cmps-wp-commitment-details-dialog--thead-btn cmps-cdk-font-size-16p cmps-cdk-font-bold cmps-cdk-color-black cmps-cdk-text-left"
                                >
                                    {{ _i18n._9473_DAYS_ACTIVE | translate }}
                                </span>
                                <cmps-icon
                                    [svgIcon]="
                                        _sorter?.columnId !== c
                                            ? 'unfold-more-horizontal'
                                            : _sorter?.sortOrder ===
                                              _SortOrder.ASC
                                            ? 'chevron-up'
                                            : 'chevron-down'
                                    "
                                ></cmps-icon>
                            </button>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.METRIC
                            "
                        >
                            <button
                                cmpsButton
                                class="cmps-button--no-bg cmps-cdk-p-0 cmps-cdk-justify-content-flex-start"
                                (click)="_onColumnSortClick(c)"
                            >
                                <span
                                    cmpsButtonLabel
                                    class="cmps-wp-commitment-details-dialog--thead-btn cmps-cdk-font-size-16p cmps-cdk-font-bold cmps-cdk-color-black cmps-cdk-text-left"
                                >
                                    {{ _i18n._713_METRIC | translate }}
                                </span>
                                <cmps-icon
                                    [svgIcon]="
                                        _sorter?.columnId !== c
                                            ? 'unfold-more-horizontal'
                                            : _sorter?.sortOrder ===
                                              _SortOrder.ASC
                                            ? 'chevron-up'
                                            : 'chevron-down'
                                    "
                                ></cmps-icon>
                            </button>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.BEHAVIOUR
                            "
                        >
                            <button
                                cmpsButton
                                class="cmps-button--no-bg cmps-cdk-p-0 cmps-cdk-justify-content-flex-start"
                                (click)="_onColumnSortClick(c)"
                            >
                                <span
                                    cmpsButtonLabel
                                    class="cmps-wp-commitment-details-dialog--thead-btn cmps-cdk-font-size-16p cmps-cdk-font-bold cmps-cdk-color-black cmps-cdk-text-left"
                                >
                                    {{ _i18n._7361_FOCUS | translate }}
                                </span>
                                <cmps-icon
                                    [svgIcon]="
                                        _sorter?.columnId !== c
                                            ? 'unfold-more-horizontal'
                                            : _sorter?.sortOrder ===
                                              _SortOrder.ASC
                                            ? 'chevron-up'
                                            : 'chevron-down'
                                    "
                                ></cmps-icon>
                            </button>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.DISPOSITION
                            "
                        >
                            <div>{{ _i18n._7332_DISPOSITION | translate }}</div>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.STATE
                            "
                        >
                            <button
                                cmpsButton
                                class="cmps-button--no-bg cmps-cdk-p-0 cmps-cdk-justify-content-flex-start"
                                (click)="_onColumnSortClick(c)"
                            >
                                <span
                                    cmpsButtonLabel
                                    class="cmps-wp-commitment-details-dialog--thead-btn cmps-cdk-font-size-16p cmps-cdk-font-bold cmps-cdk-color-black cmps-cdk-text-left"
                                >
                                    {{ _i18n._11202_STATE | translate }}
                                </span>
                                <cmps-icon
                                    [svgIcon]="
                                        _sorter?.columnId !== c
                                            ? 'unfold-more-horizontal'
                                            : _sorter?.sortOrder ===
                                              _SortOrder.ASC
                                            ? 'chevron-up'
                                            : 'chevron-down'
                                    "
                                ></cmps-icon>
                            </button>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.CALCULATION_TYPE
                            "
                        >
                            <div>{{ _i18n._76_TYPE | translate }}</div>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.IMPROVEMENT_PERCENTAGE
                            "
                        >
                            <button
                                cmpsButton
                                class="cmps-button--no-bg cmps-cdk-p-0 cmps-cdk-justify-content-flex-start"
                                (click)="_onColumnSortClick(c)"
                            >
                                <span
                                    cmpsButtonLabel
                                    class="cmps-wp-commitment-details-dialog--thead-btn cmps-cdk-font-size-16p cmps-cdk-font-bold cmps-cdk-color-black cmps-cdk-text-left"
                                >
                                    {{
                                        _i18n._10062_PERCENT_IMPROVEMENT
                                            | translate
                                    }}
                                </span>
                                <cmps-icon
                                    [svgIcon]="
                                        _sorter?.columnId !== c
                                            ? 'unfold-more-horizontal'
                                            : _sorter?.sortOrder ===
                                              _SortOrder.ASC
                                            ? 'chevron-up'
                                            : 'chevron-down'
                                    "
                                ></cmps-icon>
                            </button>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.WINNING_THRESHOLD
                            "
                        >
                            <div>
                                {{ _i18n._11273_WINNING_THRESHOLD | translate }}
                            </div>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.INITIAL_VALUE
                            "
                        >
                            <div>
                                {{ _i18n._11272_START_VALUE | translate }}
                            </div>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.CURRENT_VALUE
                            "
                        >
                            <div>
                                {{ _i18n._9302_CURRENT_VALUE | translate }}
                            </div>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.WINS_AT
                            "
                        >
                            <div>
                                {{ _i18n._11203_WINS_AT | translate }}
                            </div>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.STATUS
                            "
                        >
                            <div>{{ _i18n._127_STATUS | translate }}</div>
                        </th>
                        <th
                            class="cmps-cdk-pr-2"
                            *ngSwitchCase="
                                _CommitmentDetailsDialogColumnId.VIEW_COMMITMENT
                            "
                        >
                            <div>
                                {{ _i18n._11198_VIEW_COMMITMENT | translate }}
                            </div>
                        </th>
                    </ng-container>
                </ng-container>
            </thead>
            <tbody
                class="cmps-wp-commitment-details-dialog--tbody cmps-cdk-font-size-14p"
            >
                <tr>
                    <td class="cmps-cdk-p-0dot25"></td>
                </tr>
                <ng-container
                    *ngFor="let d of _sorter.goalCommitments; let i = index"
                >
                    <tr
                        class="cmps-cdk-align-items-center"
                        [class.cmps-cdk-bg-color-grey-100]="i % 2 === 0"
                    >
                        <ng-container *ngFor="let c of _data.columns">
                            <ng-container [ngSwitch]="c">
                                <td
                                    class="cmps-cdk-pl-0dot5 cmps-cdk-pr-2 cmps-cdk-py-0dot5"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.DIRECT_REPORT
                                    "
                                >
                                    <div>
                                        {{ d.user?.firstName?.trim() ?? '' }}
                                        {{ d.user?.lastName?.trim() ?? '' }}
                                    </div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.START_DATE
                                    "
                                >
                                    <div>
                                        {{
                                            d.data.goalStartDate
                                                | cmpsDate: 'MMM dd, y'
                                        }}
                                    </div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.DAYS_ACTIVE
                                    "
                                >
                                    <div>{{ d.data.ageGoal ?? '' }}</div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.METRIC
                                    "
                                >
                                    <div>{{ d.metric.fullName ?? '' }}</div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.BEHAVIOUR
                                    "
                                >
                                    <div>{{ d.behaviour.name ?? '' }}</div>
                                    <div>{{ d.subBehaviour.name ?? '' }}</div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.DISPOSITION
                                    "
                                >
                                    <div>
                                        {{ d.excludedReason.reason ?? '' }}
                                    </div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.STATE
                                    "
                                >
                                    <div
                                        class="cmps-cdk-d-flex cmps-cdk-align-items-center"
                                        *ngIf="d.data.winning > 0"
                                    >
                                        <div
                                            class="cmps-cdk-min-h-12p cmps-cdk-min-w-12px cmps-cdk-border-radius-4px cmps-cdk-mr-0dot25 cmps-cdk-bg-gradient-green-100-0"
                                        ></div>
                                        <div>
                                            {{
                                                _i18n._10085_WINNING | translate
                                            }}
                                        </div>
                                    </div>
                                    <div
                                        class="cmps-cdk-d-flex cmps-cdk-align-items-center"
                                        *ngIf="d.data.neutral > 0"
                                    >
                                        <div
                                            class="cmps-cdk-min-h-12p cmps-cdk-min-w-12px cmps-cdk-border-radius-4px cmps-cdk-mr-0dot25 cmps-cdk-bg-gradient-grey-400-0"
                                        ></div>
                                        <div>
                                            {{
                                                _i18n._11154_IMPROVING
                                                    | translate
                                            }}
                                        </div>
                                    </div>
                                    <div
                                        class="cmps-cdk-d-flex cmps-cdk-align-items-center"
                                        *ngIf="d.data.losing > 0"
                                    >
                                        <div
                                            class="cmps-cdk-min-h-12p cmps-cdk-min-w-12px cmps-cdk-border-radius-4px cmps-cdk-mr-0dot25 cmps-cdk-bg-gradient-red-100-0"
                                        ></div>
                                        <div>
                                            {{
                                                _i18n._11155_DECLINING
                                                    | translate
                                            }}
                                        </div>
                                    </div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.CALCULATION_TYPE
                                    "
                                >
                                    <div>
                                        {{
                                            (d.data.calculationType
                                                ?.toLowerCase()
                                                ?.trim() ===
                                            _WpCalculationType.ACTUAL
                                                ? _WpCalculationTypeToLabel[
                                                      _WpCalculationType.ACTUAL
                                                  ]
                                                : _WpCalculationTypeToLabel[
                                                      _WpCalculationType
                                                          .PERCENT_TO_TARGET
                                                  ]
                                            ) | translate
                                        }}
                                    </div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.IMPROVEMENT_PERCENTAGE
                                    "
                                >
                                    <div>
                                        {{
                                            d.data.percentageChangeVariance
                                                | cmpsSdpPercent
                                        }}
                                    </div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.WINNING_THRESHOLD
                                    "
                                >
                                    <div>
                                        {{
                                            d.data.winningThresholdConfig
                                                | cmpsSdpPercent
                                        }}
                                    </div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.INITIAL_VALUE
                                    "
                                >
                                    <div>
                                        {{
                                            d.data.calculationType
                                                ?.toLowerCase()
                                                ?.trim() ===
                                            _WpCalculationType.ACTUAL
                                                ? (d.data.initialPerformance
                                                  | cmpsSdpNumber)
                                                : (d.data.initialPerToTarget
                                                  | cmpsSdpPercent)
                                        }}
                                    </div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.CURRENT_VALUE
                                    "
                                >
                                    <div>
                                        {{
                                            d.data.calculationType
                                                ?.toLowerCase()
                                                ?.trim() ===
                                            _WpCalculationType.ACTUAL
                                                ? (d.data.finalPerformance
                                                  | cmpsSdpNumber)
                                                : (d.data.finalPerToTarget
                                                  | cmpsSdpPercent)
                                        }}
                                    </div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.WINS_AT
                                    "
                                >
                                    <div>
                                        {{
                                            d.data.calculationType
                                                ?.toLowerCase()
                                                ?.trim() ===
                                            _WpCalculationType.ACTUAL
                                                ? (d.data.winningThresholdResult
                                                  | cmpsSdpNumber)
                                                : (d.data.winningThresholdResult
                                                  | cmpsSdpPercent)
                                        }}
                                    </div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.STATUS
                                    "
                                >
                                    <div
                                        [class.cmps-cdk-color-green-100]="
                                            d.data.commitmentStatusId !==
                                            _CoachingEventStatus.CLOSED
                                        "
                                    >
                                        {{
                                            (d.data.commitmentStatusId ===
                                            _CoachingEventStatus.CLOSED
                                                ? _i18n._7440_CLOSED
                                                : _i18n._125_ACTIVE
                                            ) | translate
                                        }}
                                    </div>
                                </td>
                                <td
                                    class="cmps-cdk-pr-2"
                                    *ngSwitchCase="
                                        _CommitmentDetailsDialogColumnId.VIEW_COMMITMENT
                                    "
                                >
                                    <button
                                        cmpsIconButton
                                        class="cmps-icon-button--sm"
                                        (click)="
                                            _onViewCommitmentClick(
                                                d.user.userId,
                                                d.data.commitmentId
                                            )
                                        "
                                    >
                                        <cmps-icon
                                            svgIcon="folder-account-outline"
                                        ></cmps-icon>
                                        <div class="cmps-cdk-ml-0dot5">
                                            {{
                                                _i18n._11198_VIEW_COMMITMENT
                                                    | translate
                                            }}
                                        </div>
                                    </button>
                                </td>
                            </ng-container>
                        </ng-container>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </cmps-dialog-body>
</cmps-dialog>
